import './InterestConflicts.scss'
import React, { Component } from 'react'
import {withRouter} from '../../helpers/withRouter'
import { withTranslation } from 'react-i18next'
import { Page, PageBottomBar, PageContent, PageHeader, PageTopBar } from '../../layouts/Private/components'
import { Content, Sidebar, Wrapper } from './layout'
import { DashboardPage, SolicitudesPage, FormManagerPage, ReportingPage } from './components'
import formTypeValidator, { mapCategorias } from '../../helpers/formTypeValidator';

class InterestConflicts extends Component {
	state = {
		activeTab: 'tab-dashboard',
		breadcrumbs: this.getBreadcrumbs(),
        categories: [],
        showTabForms: false,
		fromDashboard: false,
		defaultFilters: {},
		keySidebar: 1,
		filters: {},
		types: null
	}

	async componentDidMount() {
		const { match, currentUser } = this.props;

		let { filters } = this.state;
		if (match.params && match.params.params) {
				const p = JSON.parse(atob(match.params.params));
				filters = {...filters, ...p};
			this.setState({
				defaultFilters: filters,
				activeTab:filters.tab
			});
		}
        const types = formTypeValidator(currentUser, null, false);
        const categories = [...new Set(types.flatMap(type => mapCategorias[type] || []))];
        this.setState({ categories });

    }

	getBreadcrumbs() {
		const { t } = this.props

		const breadcrumbs = [
			{ title: t('messages.aml.declarationsManagement'), icon: 'form', link: '/declaraciones' },
		]

		return breadcrumbs
	}

	handleTabChange(activeTab, filters) {
        if(this.state.activeTab !== activeTab && activeTab === 'tab-forms' && this.state.fromDashboard) {
            this.setState({
				fromDashboard: false,
				defaultFilters: { },
				keySidebar: Math.random()})
        }
        this.setState({activeTab, filters, randomKey: Math.random()})
    }

    handleTabForms(filters, module='forms') {
        window.scrollTo(0, 0)
        if(module === 'forms') {
            //Marca filtro en redirección dashboard
            const typeToFilter = { ...filters };
            if (typeToFilter.typeDeclaration) {
                typeToFilter.typesDeclaration = [typeToFilter.typeDeclaration];
                delete typeToFilter.typeDeclaration;
            }

            this.setState({
                activeTab: 'tab-forms',
                fromDashboard: true,
                showTabAlertas: true,
                filters: typeToFilter,
                defaultFilters: typeToFilter,
                keySidebar: Math.random()
            })
        } else if(module === 'records') {
            const { history } = this.props
            const params = btoa(JSON.stringify(filters))
            history.push("/registro/" + params)
        }
    }

	handleChangeShowTabForms(show) {
        this.setState({showTabForms: show})
    }

	render() {
		const { activeTab, breadcrumbs, categories, showTabForms, keySidebar, defaultFilters, types } = this.state
		const { currentUser, t } = this.props

		return (
			<div className="cdi">
				<PageTopBar breadcrumbs={ breadcrumbs } />
				<Page>
					<PageHeader
						title={t('messages.aml.declarationsManagement')}
						icon="form"
						description={t('messages.aml.declarationsManagementDesc')}
						/>
					<PageContent>
						<Wrapper>
							<Sidebar
								key={keySidebar}
								currentUser={currentUser}
								activeTab={ activeTab }
								onTabChange={ this.handleTabChange.bind(this) }
								showTabForms={showTabForms}
                                handleChangeShowTabForms={this.handleChangeShowTabForms.bind(this)}
                                defaultFilters={defaultFilters}
                                categories={categories}
                                types={types}
							/>
							<Content>
								{ activeTab === 'tab-dashboard' && <DashboardPage currentUser={currentUser} handleTabForms={this.handleTabForms.bind(this) } /> }
								{ activeTab === 'tab-solicitudes' && <SolicitudesPage currentUser={currentUser} /> }
								{ activeTab === 'tab-forms' && <FormManagerPage key={this.state.randomKey} currentUser={currentUser} categories={categories} filtersSideBar={defaultFilters} /> }
								{ activeTab === 'tab-reporting' && <ReportingPage currentUser = {currentUser}/> }
							</Content>
						</Wrapper>
					</PageContent>
				</Page>
				<PageBottomBar breadcrumbs={ breadcrumbs } />
			</div>
		)
	}
}
export default withRouter(withTranslation()(InterestConflicts))
